import { DeviceType } from 'src/common/enumerations/device-type';
import { ITenderAdd } from 'src/common/interfaces/dtos/IPreTenderAdd';
import { TenderParameters } from 'src/tendering/interfaces/tender-parameters';
import { store } from 'src/common/redux/configure-store';
import { DeviceResponse } from 'src/devices/rds-connection';
import { EntryMethod } from 'src/common/enumerations/entry-method';

export const MicrEndorsementTitle = 'MicrEndorsementTitle';
export const MicrInsertCheckFront = 'MICRInsertCheckFront';
export const MicrInsertCheckBack = 'MICRInsertCheckBack';
export const MicrScanCheck = 'MICRScanCheck';
export const MicrInsertCheck = 'MICRInsertCheck';
export const MicrValidationTitle = 'MicrValidationTitle';
export const ProcessingIndication = 'ProcessingIndication';

export enum CheckSide {
  Front = 'Front',
  Back = 'Back',
  Both = 'Both',
}

export const hasMICR = (): boolean => {
  const { deviceStatus } = store.getState();
  return deviceStatus.devices.some(
    device => device.deviceType === DeviceType.MICR && device.initialized,
  );
};

export const parseCheckData = (deviceResponse?: DeviceResponse): TenderParameters[] => {
  if (!deviceResponse) {
    return defaultMissingParams;
  }
  const { routingNumber = '', accountNumber = '', checkNumber = '' } = deviceResponse.metaDataMap;
  const transitNumber: TenderParameters = {
    name: 'TransitNumber',
    value: routingNumber,
  };
  const acctNumber: TenderParameters = {
    name: 'AccountNumber',
    value: accountNumber,
  };
  const chequeNumber: TenderParameters = {
    name: 'ChequeNumber',
    value: checkNumber,
  };
  return [transitNumber, acctNumber, chequeNumber];
};

export const getMICRData = (): TenderParameters[] | undefined => {
  const { routingNumber = '', accountNumber = '', checkNumber = '' } = store.getState().micr;
  if (routingNumber === '' || accountNumber === '' || checkNumber === '') {
    return undefined;
  }

  const transitNumber: TenderParameters = {
    name: 'TransitNumber',
    value: routingNumber,
  };
  const acctNumber: TenderParameters = {
    name: 'AccountNumber',
    value: accountNumber,
  };
  const chequeNumber: TenderParameters = {
    name: 'ChequeNumber',
    value: checkNumber,
  };
  return [transitNumber, acctNumber, chequeNumber];
};

export const parseTenderDetails = (
  tenderDetails: ITenderAdd,
  missingParams: TenderParameters[],
): ITenderAdd => {
  const tenderAdd: ITenderAdd = { ...tenderDetails };
  tenderAdd.tender = {
    ...tenderDetails.tender,
    entryMethod: EntryMethod.Automatic,
    extendedPaymentParameters: missingParams,
    endorsementPrinted: false,
  };
  return tenderAdd;
};

const defaultMissingParams: TenderParameters[] = [
  { name: 'TransitNumber', value: '' },
  { name: 'AccountNumber', value: '' },
  { name: 'ChequeNumber', value: '' },
];

export interface CheckEndorsementConfig {
  endorsementId?: string;
  id?: string;
  displayName?: string;
  receiptLinesFront?: receiptLines[];
  receiptLinesBack?: receiptLines[];
  enterpriseUnitIds?: string[];
  tenders?: string[];
}

interface receiptLines {
  lineDefinitionName: string;
  templateName: string;
  layout: string | null;
  section: string | null;
}

export interface EndorsementPrintDto {
  utcDateTime?: string;
  isTrainingMode?: boolean;
  owner: Owner;
  cartSequenceNumber: string;
  tenderId?: string;
  tenderName?: string;
  amount?: number;
  cartTotalAmount?: number;
}

export interface Owner {
  cashierUsername?: string;
  cashierDisplayName?: string;
}
